import { type Provider } from '@angular/core';
import {
  type MissingTranslationHandlerParams,
  provideMissingTranslationHandler,
  provideTranslateCompiler,
  provideTranslateLoader,
  provideTranslateService,
  type TranslationObject,
} from '@ngx-translate/core';
import { of, throwError } from 'rxjs';

import cs from './catalogues/cs.json';
import de from './catalogues/de.json';
import en from './catalogues/en.json';
import es from './catalogues/es.json';
import { createIcuCompiler } from './icu-compiler';
import { DEFAULT_LOCALE } from './locales';

const CATALOGUES: ReadonlyMap<string, TranslationObject> = new Map([
  ['cs', cs],
  ['de', de],
  ['en', en],
  ['es', es],
]);

// Replace only this loader to introduce HTTP delivery; components and locale owners stay unchanged.
export function provideImaTranslations(): Provider[] {
  return provideTranslateService({
    lang: DEFAULT_LOCALE,
    fallbackLang: DEFAULT_LOCALE,
    compiler: provideTranslateCompiler(createIcuCompiler),
    loader: provideTranslateLoader(() => ({
      getTranslation: (locale: string) => {
        const catalogue = CATALOGUES.get(locale);

        return catalogue
          ? of({ ...catalogue })
          : throwError(() => new Error(`No local translation catalogue for "${locale}".`));
      },
    })),
    missingTranslationHandler: provideMissingTranslationHandler(() => ({
      handle: ({ key }: Readonly<MissingTranslationHandlerParams>) => {
        console.error(`[IMA i18n] Missing English translation: ${key}`);

        return key;
      },
    })),
  });
}
